<!--<div [ngClass]="{'green': isConnected, 'red': !isConnected}" class="header"> CONNECTION </div>-->
<div id="appContainer">
  <app-loader></app-loader>
  <app-console></app-console>
  <router-outlet></router-outlet>
</div>
